// RealPlus `listing_type_code` (single-letter, stored raw from the feed).
// We only surface the three codes the team cares about; any other code
// (e.g. "C") returns null so nothing is rendered.
const LISTING_TYPE_LABELS = {
  B: { label: "Participant Only", short: "Participant Only", color: "#8a6d00", bg: "#fff8e1", border: "#ffe082" },
  X: { label: "Co-Exclusive", short: "Co-Exclusive", color: "#6a1b9a", bg: "#f3e5f5", border: "#ce93d8" },
  F: { label: "For Sale By Owner", short: "FSBO", color: "#00695c", bg: "#e0f2f1", border: "#80cbc4" },
};

// Returns {label, short, color, bg, border} for B/X/F, else null.
export function getListingTypeLabel(code) {
  if (!code) return null;
  return LISTING_TYPE_LABELS[String(code).trim().toUpperCase()] || null;
}
